<h3 class="collapsible-heading">
    <button
        class="collapsible-button"
        [attr.aria-expanded]="open()"
        [attr.aria-controls]="uid"
        (click)="toggleOpen()"
    >
        <span class="collapsible-title">
            @if (icon) {
                <i
                    [ctrlIcon]="icon"
                    class="collapsible-icon"
                ></i>
            }
            <span>
                {{ title }}
                @if (alert) {
                    <br />
                    <span class="collapsible-subtitle c:red">{{ alert }}</span>
                } @else if (subtitle) {
                    <br />
                    <span class="collapsible-subtitle">{{ subtitle }}</span>
                }
            </span>
        </span>
        <ng-content select="[collapsibleHeading]"></ng-content>
        <i
            ctrlIcon="chevron_right"
            class="collapsible-chevron c:blue-1"
        ></i>
    </button>
</h3>
<div
    class="collapsible-content"
    [ngClass]="{ '-hidden': !open() }"
    [id]="uid"
>
    <ng-content></ng-content>
</div>
